/** components/Card — a titled panel. The base surface primitive for every section. */
import type { ReactNode } from 'react';

interface CardProps {
  readonly title?: ReactNode;
  readonly hint?: ReactNode;
  readonly actions?: ReactNode;
  readonly flush?: boolean;
  readonly children: ReactNode;
}

export function Card({ title, hint, actions, flush, children }: CardProps): JSX.Element {
  return (
    <section className="card">
      {(title || actions) && (
        <header className="card__head">
          {title && <h2 className="card__title">{title}</h2>}
          {hint && <span className="card__hint">{hint}</span>}
          {actions}
        </header>
      )}
      <div className={flush ? 'card__body card__body--flush' : 'card__body'}>{children}</div>
    </section>
  );
}
